import { connect as en_connect } from "../en/connect";

/** connect — ES slice. */
export const connect: Record<keyof typeof en_connect, string> = {
  connect_launcher_title: "Conectar",
  connect_launcher_subtitle:
    "Haz match en persona: muestra tu QR para que alguien lo escanee, o confirma un escaneo para conectar al instante.",
  connect_launcher_open_button: "Abrir Conectar",

  // Shared error / action labels
  connect_error_title: "No se pudo cargar",
  connect_error_subtitle: "Revisa tu conexión e inténtalo de nuevo",
  connect_action_try_again: "Reintentar",
  connect_action_close: "Cerrar",
  connect_action_done: "Listo",
  connect_action_continue: "Continuar",

  // QR screen (owner home)
  connect_qr_title: "Tu código QR",
  connect_qr_hint:
    "Pide que escaneen este código QR para hacer match contigo automáticamente",
  connect_qr_error_title: "No se pudo cargar tu QR",

  // Scan result (scanner B)
  connect_scan_request_sent_heading: "Solicitud enviada",
  connect_scan_request_sent_to: "a {name}",
  connect_scan_pending_status: "Match pendiente",
  connect_scan_already_connected_heading: "Ya estás conectado con {name}",
  connect_scan_self_heading: "No puedes conectarte contigo mismo",
  connect_scan_invalid_title: "Enlace no válido",
  connect_scan_invalid_subtitle: "Este código QR ya no es válido",

  // Match / consent gate (owner A)
  connect_match_error_title: "No se pudo cargar esta solicitud",
  connect_match_heading: "¿Hacer match con {name}?",
  connect_match_button: "Match",
  connect_match_matching: "Haciendo match…",
  connect_match_decline: "Ahora no",
  connect_match_matched_heading: "Hiciste match con {name}",
  connect_match_expired_heading: "Esta solicitud ha caducado",

  // Toasts
  connect_toast_matched_with: "Match con {name}",
  connect_toast_matched: "¡Match!",
  connect_toast_match_failed: "No se pudo crear el match",
};
